document.addEventListener('mousemove', (e) => {
  const trail = document.createElement('div');
  trail.className = 'paw-trail';
  trail.style.left = `${e.pageX}px`;
  trail.style.top = `${e.pageY}px`;
  document.body.appendChild(trail);

  setTimeout(() => {
    trail.remove();
  }, 600);
});

const cursor = document.createElement('div');
cursor.classList.add('custom-cursor');
document.body.appendChild(cursor);

// Track the mouse position and update cursor's position
document.addEventListener('mousemove', (e) => {
  cursor.style.left = `${e.pageX - 25}px`; // Offset for center alignment
  cursor.style.top = `${e.pageY - 25}px`;
});

// Add a 'wagging' effect when hovering over buttons
const buttons = document.querySelectorAll('button');
buttons.forEach(button => {
  button.addEventListener('mouseenter', () => {
    cursor.style.animation = 'wagTail 0.2s infinite';
  });

  button.addEventListener('mouseleave', () => {
    cursor.style.animation = 'wagTail 0.5s infinite';
  });
});

